import { Stack, Text, Inline } from 'braid-design-system';
import type React from 'react';

interface Props {
  location: Record<string, string>;
}

export const OfficeInfo = ({ location }: Props) => {
  const { name, address, city, state, post_code, fax, operating_hours } =
    location;
  return (
    <Stack space="small">
      {Boolean(name) && <Text weight="strong">{name}</Text>}
      {Boolean(address) && <Text>{address ?? ''}</Text>}
      {Boolean(city || state || post_code) && (
        <Inline space="xsmall">
          {Boolean(city) && <Text>{city}</Text>}
          {Boolean(state) && <Text>{state}</Text>}
          {Boolean(post_code) && <Text>{post_code}</Text>}
        </Inline>
      )}
      {Boolean(fax) && <Text>Fax: {fax}</Text>}
      <Text>{operating_hours ?? ''}</Text>
    </Stack>
  );
};

export default OfficeInfo;
